/**
 * Product Carousel Navigation
 * Handles slide navigation and thumbnail sync for product images
 */
(function() {
  'use strict';

  function initProductCarousel() {
    const wrapper = document.querySelector('.product__slides-wrapper');
    if (!wrapper) return;

    const productImages = wrapper.closest('.product__images');
    const slides = wrapper.querySelector('.product__slides');
    const prevBtn = wrapper.querySelector('[data-slides-arrow-prev]');
    const nextBtn = wrapper.querySelector('[data-slides-arrow-next]');
    const thumbs = document.querySelectorAll('.product__thumb[data-thumb-item]');

    if (!slides) return;
    const hasButtons = prevBtn && nextBtn;

    const isSliderMode = productImages && productImages.classList.contains('product__images--mobile-slider');
    const allSlides = slides.querySelectorAll('.product__slide');
    let currentIndex = 0;

    const updateArrowsVisibility = () => {
      if (!hasButtons) return;

      // Next arrow always visible for looping
      nextBtn.classList.remove('jc-hidden');
      nextBtn.classList.add('jc-flex');

      if (isSliderMode) {
        const scrollLeft = slides.scrollLeft;

        if (scrollLeft <= 5) {
          prevBtn.classList.add('jc-hidden');
          prevBtn.classList.remove('jc-flex');
        } else {
          prevBtn.classList.remove('jc-hidden');
          prevBtn.classList.add('jc-flex');
        }
      } else {
        if (currentIndex <= 0) {
          prevBtn.classList.add('jc-hidden');
          prevBtn.classList.remove('jc-flex');
        } else {
          prevBtn.classList.remove('jc-hidden');
          prevBtn.classList.add('jc-flex');
        }
      }
    };

    const goToSlide = (index) => {
      // Loop to first when going past last
      if (index >= thumbs.length) index = 0;
      if (index < 0) return;
      currentIndex = index;
      const thumb = thumbs[index];
      if (thumb) {
        const link = thumb.querySelector('[data-thumb-link]');
        if (link) link.click();
      }
      updateArrowsVisibility();
    };

    const getSlideWidth = () => {
      const slide = slides.querySelector('.product__slide');
      return slide ? slide.offsetWidth + 15 : slides.offsetWidth;
    };

    if (hasButtons) {
      prevBtn.addEventListener('click', () => {
        if (isSliderMode) {
          slides.scrollBy({ left: -getSlideWidth(), behavior: 'smooth' });
        } else {
          goToSlide(currentIndex - 1);
        }
      });

      nextBtn.addEventListener('click', () => {
        if (isSliderMode) {
          const maxScroll = slides.scrollWidth - slides.clientWidth;
          if (slides.scrollLeft >= maxScroll - 5) {
            // Loop to first image
            slides.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            slides.scrollBy({ left: getSlideWidth(), behavior: 'smooth' });
          }
        } else {
          goToSlide(currentIndex + 1);
        }
      });
    }

    // Track current index when thumbs are clicked
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        currentIndex = index;
        updateArrowsVisibility();
      });
    });

    // Observe active thumbnail changes (for swipe sync)
    const updateCurrentIndexFromActive = () => {
      thumbs.forEach((thumb, index) => {
        if (thumb.classList.contains('is-active')) {
          currentIndex = index;
        }
      });
      updateArrowsVisibility();
    };

    const observer = new MutationObserver(updateCurrentIndexFromActive);
    thumbs.forEach(thumb => {
      observer.observe(thumb, { attributes: true, attributeFilter: ['class'] });
    });

    if (isSliderMode) {
      slides.addEventListener('scroll', updateArrowsVisibility);
    }
    updateCurrentIndexFromActive();

    // Prevent page scroll on horizontal swipes (diagonal swipe fix)
    let startX = 0, startY = 0, direction = null;

    const resetTouch = () => {
      startX = startY = 0;
      direction = null;
    };

    slides.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return; // Ignore multi-touch
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      direction = null;
    }, { passive: true });

    slides.addEventListener('touchmove', (e) => {
      if (!startX || e.touches.length !== 1) return;

      const touch = e.touches[0];
      const diffX = Math.abs(touch.clientX - startX);
      const diffY = Math.abs(touch.clientY - startY);

      // Lock direction after 8px movement, with 1.2x bias toward horizontal
      if (direction === null && (diffX > 8 || diffY > 8)) {
        direction = diffX >= diffY * 1.2 ? 'horizontal' : 'vertical';
      }

      if (direction === 'horizontal') e.preventDefault();
    }, { passive: false });

    slides.addEventListener('touchend', resetTouch, { passive: true });
    slides.addEventListener('touchcancel', resetTouch, { passive: true });

  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCarousel);
  } else {
    initProductCarousel();
  }
})();
